module.exports = __webpack_public_path__ + "img/Mini_arrow_right2.32ade528.png";